export const defaultIngredients: string = 'Select an option to view the ingredients'